import { Button } from '@carbon/react';
import { Add } from '@carbon/react/icons';

const ActionButton = (props) => <Button {...props} renderIcon={Add} />;

export default ActionButton;
